export type SignupFormField = { name: string; label: string };

/** The customer fields that can be asked by the public registration form (label is an i18n key) */
export const SIGNUP_FORM_FIELDS: SignupFormField[] = [
    { name: 'first_name', label: 'CUSTOMERS.SHOWCASE.FIRST_NAME' },
    { name: 'last_name', label: 'CUSTOMERS.SHOWCASE.LAST_NAME' },
    { name: 'company_name', label: 'CUSTOMERS.SHOWCASE.COMPANY_NAME' },
    { name: 'gender', label: 'CUSTOMERS.SHOWCASE.GENDER' },
    { name: 'birthdate', label: 'CUSTOMERS.SHOWCASE.BIRTHDATE' },
    { name: 'vat_code', label: 'CUSTOMERS.SHOWCASE.VAT_CODE' },
    { name: 'tax_code', label: 'CUSTOMERS.SHOWCASE.TAX_CODE' },
    { name: 'billing_city', label: 'CUSTOMERS.SHOWCASE.BILLING_CITY' },
    { name: 'billing_country', label: 'CUSTOMERS.SHOWCASE.BILLING_COUNTRY' },
    { name: 'billing_prov', label: 'CUSTOMERS.SHOWCASE.BILLING_PROV' },
    { name: 'billing_street', label: 'CUSTOMERS.SHOWCASE.BILLING_STREET' },
    { name: 'billing_zip', label: 'CUSTOMERS.SHOWCASE.BILLING_ZIP' },
    { name: 'sdi_code', label: 'CUSTOMERS.SHOWCASE.SDI_CODE' },
    { name: 'mobile', label: 'CUSTOMERS.SHOWCASE.MOBILE' },
    { name: 'phone', label: 'CUSTOMERS.SHOWCASE.PHONE' },
    { name: 'email', label: 'CUSTOMERS.SHOWCASE.EMAIL' },
    { name: 'email_pec', label: 'CUSTOMERS.SHOWCASE.EMAIL_PEC' },
    { name: 'external_id', label: 'CUSTOMERS.SHOWCASE.EXTERNAL_ID' },
    { name: 'facebook', label: 'CUSTOMERS.SHOWCASE.FACEBOOK' },
    { name: 'instagram', label: 'CUSTOMERS.SHOWCASE.INSTAGRAM' },
    { name: 'linkedin', label: 'CUSTOMERS.SHOWCASE.LINKEDIN' },
    { name: 'twitter', label: 'CUSTOMERS.SHOWCASE.TWITTER' },
    { name: 'shipping_city', label: 'CUSTOMERS.SHOWCASE.SHIPPING_CITY' },
    { name: 'shipping_country', label: 'CUSTOMERS.SHOWCASE.SHIPPING_COUNTRY' },
    { name: 'shipping_prov', label: 'CUSTOMERS.SHOWCASE.SHIPPING_PROV' },
    { name: 'shipping_street', label: 'CUSTOMERS.SHOWCASE.SHIPPING_STREET' },
    { name: 'shipping_zip', label: 'CUSTOMERS.SHOWCASE.SHIPPING_ZIP' },
    { name: 'custom_1', label: 'CUSTOMERS.SHOWCASE.CUSTOM_1' },
    { name: 'custom_2', label: 'CUSTOMERS.SHOWCASE.CUSTOM_2' },
    { name: 'custom_3', label: 'CUSTOMERS.SHOWCASE.CUSTOM_3' },
    { name: 'custom_4', label: 'CUSTOMERS.SHOWCASE.CUSTOM_4' },
    { name: 'custom_5', label: 'CUSTOMERS.SHOWCASE.CUSTOM_5' },
    { name: 'custom_6', label: 'CUSTOMERS.SHOWCASE.CUSTOM_6' },
    { name: 'custom_7', label: 'CUSTOMERS.SHOWCASE.CUSTOM_7' },
    { name: 'custom_8', label: 'CUSTOMERS.SHOWCASE.CUSTOM_8' },
    { name: 'custom_9', label: 'CUSTOMERS.SHOWCASE.CUSTOM_9' }
];
